import { requestApi } from './Api';

export const getPatients = async (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/charts/get', params });

export const getPatientsAdmin = async (navigate, params) =>
  requestApi({ navigate, url: '/api/patient/get/multiple', params });

export const getPatient = async (navigate, params) =>
  requestApi({ navigate, url: '/api/patient/get/one', params });

export const updateProfilePicture = async (navigate, params) =>
  requestApi({ navigate, url: '/api/filestack/profile_photo', params });

export const updatePatient = async (navigate, options) =>
  requestApi({
    url: '/api/user/update',
    params: options,
    navigate
  });

export const updatePracticePatientLink = async (navigate, options) =>
  requestApi({
    url: '/api/practice/patient/link/update',
    params: options,
    navigate
  });

export const createPatient = async (navigate, options) =>
  requestApi({
    url: '/api/practice/patient/add_patient',
    params: options,
    navigate
  });

export const chartExport = async (navigate, options) =>
  requestApi({
    url: '/api/practice/charts/export',
    params: options,
    navigate
  });

export const mergePatients = async (navigate, options) =>
  requestApi({
    url: '/api/practice/charts/merge',
    params: options,
    navigate
  });

export const getPatientMessages = async (navigate, params) =>
  requestApi({
    url: '/api/messages/inbox',
    params,
    navigate
  });

export const getPatientWeightLossGoal = async (navigate, params) =>
  requestApi({
    url: '/api/patient/weight_loss_goal/get',
    params,
    navigate
  });
export const upsertPatientWeightLossGoal = async (navigate, params, onSuccess, onError) =>
  requestApi({
    url: '/api/patient/weight_loss_goal/upsert',
    params,
    navigate,
    onSuccess,
    onError
  });

export const getCheckinPatient = async (navigate, params) =>
  requestApi({ navigate, url: '/api/patient/checkin/get_patient', params });

export const getPatientForms = async (navigate, params) =>
  requestApi({ navigate, url: '/api/patient/forms/get', params });

export const getPatientICDCodes = async (navigate, params, onSuccess, onError) =>
  requestApi({
    url: '/api/patient/icd/get',
    params,
    navigate,
    onSuccess,
    onError
  });

export const updatePracticePatient = async (navigate, params) =>
  requestApi({ navigate, params, url: 'api/practice/patient/update' });

export const applySpecificSpecialty = async (navigate, params, onSuccess) =>
  requestApi({
    url: '/api/patient/insurance/apply_specific_specialty',
    params,
    navigate,
    onSuccess
  });
